var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.041,
    height: 20.041,
    viewBox: "0 0 20.041 20.041",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.724,0H1.461A1.463,1.463,0,0,0,0,1.461V5.219A1.463,1.463,0,0,0,1.461,6.68H7.724A1.463,1.463,0,0,0,9.186,5.219V1.461A1.463,1.463,0,0,0,7.724,0Zm0,0",
    transform: "translate(0 0)",
    fill: "#697384"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.724,213.332H1.461A1.463,1.463,0,0,0,0,214.793v8.768a1.463,1.463,0,0,0,1.461,1.461H7.724a1.463,1.463,0,0,0,1.461-1.461v-8.768A1.463,1.463,0,0,0,7.724,213.332Zm0,0",
    transform: "translate(0 -204.982)",
    fill: "#697384"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M285.056,341.332h-6.263a1.463,1.463,0,0,0-1.461,1.461v3.758a1.463,1.463,0,0,0,1.461,1.461h6.263a1.463,1.463,0,0,0,1.461-1.461v-3.758A1.463,1.463,0,0,0,285.056,341.332Zm0,0",
    transform: "translate(-266.476 -327.971)",
    fill: "#697384"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M285.056,0h-6.263a1.463,1.463,0,0,0-1.461,1.461v8.768a1.463,1.463,0,0,0,1.461,1.461h6.263a1.463,1.463,0,0,0,1.461-1.461V1.461A1.463,1.463,0,0,0,285.056,0Zm0,0",
    transform: "translate(-266.476 0)",
    fill: "#697384"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.a0982b8940182b2f55becef69a0a3e90.svg";
export { ForwardRef as ReactComponent };